<template>
  <div class="bottomList">
    <div
      @click="goOtherWeb(item)"
      v-for="item in bottomTips"
      :key="item.label"
      class="item"
    >
      {{ item.label }}
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bottomTips: [
        { label: "IEOU©2023", path: "" },
        {
          label: "沪ICP备19026522号-3",
          path: "https://beian.miit.gov.cn/#/Integrated/index"
        },
        { label: "隐私和法律", path: "" }
      ]
    };
  },
  methods: {
    goOtherWeb(item) {
      if (item.path) {
        window.open(item.path);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.bottomList {
  padding: 0.56rem 0 0.16rem;
  background-color: #000000;
  .item {
    text-align: center;
    margin-bottom: 0.16rem;
    color: #fff;
    font-size: 12px;
  }
}
</style>
